
<div class="wrapper-confirm-residual" [class.fadeOut]="fadeOut" (click)="closeAction()"></div>

<ng-container *ngIf="!hiddenExchangeInfo">
  <ng-container *ngTemplateOutlet="residualExchangeInfo"></ng-container>
</ng-container>

<ng-template #residualExchangeInfo>
  <div class="container-confirm-residual {{animation}} smooth-animated">
    <div class="confirm-residual-content">
      <div class="header">
        <span class="title">{{ 'USER_HISTORY_MODULE.CHANGE_FLIGHTS_MODULE.RESIDUAL_EXCHANGE_MODULE.TITLE' | transloco }}</span>
        <span class="back" (click)="closeAction()"><i aria-hidden="true" class="icon-close"></i></span>
      </div>
      <div class="body-cont" [innerHTML]="'USER_HISTORY_MODULE.CHANGE_FLIGHTS_MODULE.RESIDUAL_EXCHANGE_MODULE.CONTENT.PARAGRAPHS' | transloco">
      </div>
      <div class="confirm-residual-apply-button">
        <app-fixed-surface>
          <app-ds-button
            [labels]="{ ButtonLabel: 'USER_HISTORY_MODULE.CHANGE_FLIGHTS_MODULE.RESIDUAL_EXCHANGE_MODULE.CONTENT.ACCEPT' | transloco }"
            (clickEvent)="closeAction()">
          </app-ds-button>
        </app-fixed-surface>
      </div>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="showConfirmExchangePush">
  <ng-container *ngTemplateOutlet="confirmResidualExchange"></ng-container>
</ng-container>

<ng-template #confirmResidualExchange>
  <div class="container-confirm-residual h410 {{confirmViewAnimation}} smooth-animated">
    <div class="confirm-residual-content">
      <div class="header">
        <span class="title">{{'USER_HISTORY_MODULE.CHANGE_FLIGHTS_MODULE.RESIDUAL_EXCHANGE_MODULE.CONFIRM.TITLE' | transloco }}</span>
        <span class="back" (click)="closeAction()"><i aria-hidden="true" class="icon-close"></i></span>
      </div>
      <div class="body-cont">
        <div class="description">
          <img class="support-img" loading="lazy" [src]="supportImg | ImageCdn">
          <p>{{ 'USER_HISTORY_MODULE.CHANGE_FLIGHTS_MODULE.RESIDUAL_EXCHANGE_MODULE.CONFIRM.DESCRIPTION' | transloco }}</p>
        </div>
        <p>{{ 'USER_HISTORY_MODULE.CHANGE_FLIGHTS_MODULE.RESIDUAL_EXCHANGE_MODULE.CONFIRM.INFO' | transloco }}</p>
        <p class="terms" (click)="openTerms()" [innerHTML]="'USER_HISTORY_MODULE.CHANGE_FLIGHTS_MODULE.RESIDUAL_EXCHANGE_MODULE.CONFIRM.POLICIES' | transloco"></p>
      </div>
      <div class="confirm-residual-apply-button">
        <app-fixed-surface>
          <app-ds-button
            [labels]="{ ButtonLabel: 'USER_HISTORY_MODULE.CHANGE_FLIGHTS_MODULE.RESIDUAL_EXCHANGE_MODULE.CONFIRM.ACCEPT' | transloco }"
            (clickEvent)="confirmExchangePush()">
          </app-ds-button>
        </app-fixed-surface>
      </div>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="showTerms">
  <ng-container *ngTemplateOutlet="terms"></ng-container>
</ng-container>

<ng-template #terms>
  <div class="terms-and-conditions {{termsAnimation}} smooth-animated">
    <app-terms-conditions
      [disabledBack]="true"
      (closeTerms)="closeTerms()">
    </app-terms-conditions>
  </div>
</ng-template>
 
<ng-container *ngIf="showLoaderSuccess">
  <div class="loader-success-or-error {{loaderSuccessAnimation}} smooth-animated" [class.padding]="isLoadingExchangePush$ | async">
    <ng-container *ngIf="isLoadingExchangePush$ | async; else successExchange">
      <ng-container *ngTemplateOutlet="loader"></ng-container>
    </ng-container>
  </div>
</ng-container>

<ng-template #loader>
  <app-loading-green
    [isMobile]="true"
    [maxWidth]="'92px'"
    [maxHeight]="'92px'"
    [marginLeft]="'0px'">
  </app-loading-green>
  <div class="absolute-text">{{ 'USER_HISTORY_MODULE.CHANGE_FLIGHTS_MODULE.RESIDUAL_EXCHANGE_MODULE.LOADER_MESSAGE' | transloco }}</div>
</ng-template>

<ng-template #successExchange>
  <div class="image">
    <img class="support-img" loading="lazy" [src]="supportImg | ImageCdn">
  </div>
  <div class="title">
    <span>{{ 'USER_HISTORY_MODULE.CHANGE_FLIGHTS_MODULE.RESIDUAL_EXCHANGE_MODULE.SUCCESS.TITLE' | transloco }}</span>
  </div>
  <div class="description">
    <span [innerHTML]="'USER_HISTORY_MODULE.CHANGE_FLIGHTS_MODULE.RESIDUAL_EXCHANGE_MODULE.SUCCESS.DESCRIPTION' | transloco"></span>
  </div>
  <div class="controls">
    <div class="confirm-residual-apply-button">
      <app-fixed-surface>
        <app-ds-button
          [labels]="{ ButtonLabel: 'USER_HISTORY_MODULE.CHANGE_FLIGHTS_MODULE.RESIDUAL_EXCHANGE_MODULE.SUCCESS.CONTINUE' | transloco }"
          (clickEvent)="goToHistory()">
        </app-ds-button>
      </app-fixed-surface>
    </div>
  </div>
</ng-template>

